import { setDecimalPlaces, setRateDecimalPlaces } from 'src/utils/formatAmout';
import { getLocalStorage, setLocalStorage } from 'src/utils/localStorage';
import { getParameterByName } from './parameterService';

const AMOUNT_KEY = 'DECIMAL_PLACES';
const RATE_KEY = 'DECIMAL_PLACES_RATE';

// Both setters clamp their own range and fall back to their own default, so a
// stale cache or an unexpected API value can never break rendering.
const SETTERS = {
  [AMOUNT_KEY]: setDecimalPlaces,
  [RATE_KEY]: setRateDecimalPlaces
};

export const hydrateDecimalPlacesFromCache = () => {
  try {
    Object.entries(SETTERS).forEach(([key, apply]) => {
      const cached = getLocalStorage(key);

      if (cached !== null) {
        apply(cached);
      }
    });
  } catch {
    // A private window or blocked storage must never break the boot; the
    // module defaults stand until the API responds.
  }
};

// Applied at import time, before the first render, so a refresh never flashes
// numbers formatted with the default precision.
hydrateDecimalPlacesFromCache();

const loadParameter = async (key, apply) => {
  try {
    const value = await getParameterByName(key);

    apply(value);
    setLocalStorage(key, Number(value));
  } catch {
    // Keep the cached or default value; a display preference is never
    // worth blocking the dashboard over. Each parameter is loaded
    // independently so one missing row cannot take the other down.
  }
};

export const loadDecimalPlaces = async () => {
  hydrateDecimalPlacesFromCache();

  await Promise.all(
    Object.entries(SETTERS).map(([key, apply]) => loadParameter(key, apply))
  );
};
